import { Placement } from '../../types/enums';
import { EmptyComponent } from '../helpers/EmptyComponent';
import { ModuleNameToModuleRegistry } from '../../types/types';
import summarySideBars from '../SummarySideBar';
import bottomBars from '../BottomBar';
import topBarFulls from '../TopBarFull';
import topBarSlims from '../TopBarSlim';
import informationModals from '../InformationModal';
import signInListCards from '../SignInListCard';
import signInTextCards from '../SignInTextCard';
import homeBottomCard from '../HomeBottomCard';
import { FC } from 'react';

type PlacementModuleRegistry = {
  [placementName in Placement]: Readonly<ModuleNameToModuleRegistry> | null;
};

const placementModuleRegistry: Readonly<PlacementModuleRegistry> = Object.freeze(
  {
    [Placement.SURVEY_SUMMARY_SIDE_BAR]: summarySideBars,
    [Placement.BOTTOM_BAR]: bottomBars,
    [Placement.CAROUSEL]: { ...informationModals },
    [Placement.ESCALATOR]: null,
    [Placement.LI_HOME_BOTTOM]: homeBottomCard,
    [Placement.TOP_BAR]: { ...topBarFulls, ...topBarSlims },
    [Placement.SIGN_IN_RIGHT]: { ...signInListCards, ...signInTextCards },
  }
);

const getContentModuleByName = (
  placement: Placement,
  moduleName: string
): FC => {
  const placementRegistry: Readonly<ModuleNameToModuleRegistry> | null =
    placement in placementModuleRegistry
      ? placementModuleRegistry[placement]
      : null;
  if (
    placementRegistry &&
    moduleName in placementRegistry &&
    placementRegistry[moduleName]
  ) {
    return placementRegistry[moduleName];
  }
  // Record missing module
  return EmptyComponent;
};

export default getContentModuleByName;
